import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderBulkAction, StakeholderBulkActionDto } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useBulkActions = () => {
  const { mutate: bulkActions, isPending } = useAppMutation([QueryKey.BULK_STAKEHOLDER_ACTIONS], {
    mutationFn: ({
      action,
      companyId,
      ...body
    }: {
      action: keyof typeof StakeholderBulkAction;
      companyId: string;
    } & StakeholderBulkActionDto) =>
      ApiService.post<StakeholderBulkActionDto>(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', 'bulk', StakeholderBulkAction[action]],
        },
        { body },
      ),
  });
  return { bulkActions, isPending };
};
